import React, { useState, useEffect } from 'react';
import './App.css';
import QuizForm from './components/QuizForm';
import EmailCapture from './components/EmailCapture';
import Results from './components/Results';

const trackEvent = (eventName, params = {}) => {
  if (window.gtag) {
    window.gtag('event', eventName, { app: 'find_my_lead_magnet', ...params });
  }
};

function App() {
  const [step, setStep] = useState('quiz'); // quiz, email, results

  useEffect(() => {
    trackEvent('page_viewed', { page: 'landing' });
  }, []);
  const [quizAnswers, setQuizAnswers] = useState({});
  const [recommendations, setRecommendations] = useState(null);

  // Pre-populate email if passed via URL (e.g. from FMB or ICP handoff)
  const prefillEmail = new URLSearchParams(window.location.search).get('email') || '';
  const [userEmail, setUserEmail] = useState(prefillEmail);

  const handleQuizComplete = (answers) => {
    setQuizAnswers(answers);
    setStep('email');
  };

  const handleEmailSubmit = async (email) => {
    setUserEmail(email);
    setStep('results'); // Switch immediately so loading screen shows

    try {
      const response = await fetch('https://us-central1-lead-magnet-finder.cloudfunctions.net/getLeadMagnetRecommendations', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: email,
          answers: quizAnswers
        })
      });

      const data = await response.json();
      setRecommendations(data.recommendations);
    } catch (error) {
      console.error('Error getting recommendations:', error);
      alert('Something went wrong. Please try again.');
    }
  };

  return (
    <div className="App">
      <header className="app-header">
        <h1>Find Your Perfect Lead Magnet</h1>
        <p className="subtitle">Get personalized recommendations in 5 minutes</p>
        <p style={{
          marginTop: '0.75rem',
          fontSize: '0.95rem',
          color: '#ffd700',
          fontWeight: '600',
          maxWidth: '560px',
          margin: '0.75rem auto 0',
          lineHeight: '1.6',
        }}>
          Because you already did the hard work in the ICP Assessment, this step is completely free. Your $47 unlocked everything you need to make this work.
        </p>
      </header>

      <main className="app-main">
        {step === 'quiz' && (
          <QuizForm onComplete={handleQuizComplete} />
        )}
        
        {step === 'email' && (
          <EmailCapture onSubmit={handleEmailSubmit} prefillEmail={prefillEmail} />
        )}
        
        {step === 'results' && (
          <Results 
            recommendations={recommendations} 
            email={userEmail}
          />
        )}
      </main>

      <footer className="app-footer">
        <p>Created by Designer of Content</p>
      </footer>
    </div>
  );
}

export default App;
